export const DEFAULT_FRAME_FIT = Object.freeze({ inset: 12, offsetX: 0, offsetY: 0 });

const bounded = (value, fallback, min, max) => {
  if (value === null || value === undefined || value === '') return fallback;
  const number = Number(value);
  return Number.isFinite(number) ? Math.min(max, Math.max(min, number)) : fallback;
};

export function normalizeFrameFit(fit) {
  return {
    inset: bounded(fit?.inset, DEFAULT_FRAME_FIT.inset, 0, 30),
    offsetX: bounded(fit?.offsetX, 0, -15, 15),
    offsetY: bounded(fit?.offsetY, 0, -15, 15),
  };
}

// Physical left/top coordinates intentionally remain identical in RTL and LTR.
// The original frame artwork stays centered; only its inner photo is fitted.
export function framePhotoStyle(fit, radius = '50%') {
  const { inset, offsetX, offsetY } = normalizeFrameFit(fit);
  return {
    position: 'absolute', inset: 'auto',
    left: `${inset + offsetX}%`, top: `${inset + offsetY}%`,
    width: `${100 - 2 * inset}%`, height: `${100 - 2 * inset}%`,
    borderRadius: radius, transform: 'none', boxSizing: 'border-box',
  };
}
